import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Panindiabusandcabservice() {



  const cardData =
  {
    keyword: 'Pan India Bus & Cab Service Pune',
    heading: 'Sanavi Travels: Pan India Bus & Cab Service Pune',
    headingDescription: 'Sanavi Travels offers reliable Pan India Bus & Cab Service from Pune, providing safe, comfortable, and hassle-free transportation solutions for corporate travel, group tours, outstation journeys, events, and special occasions across India. Our extensive fleet of well-maintained cabs, tempo travellers, mini buses, and luxury buses is available for both short and long-distance travel, ensuring comfort, spacious seating, and professional service. With experienced chauffeurs, nationwide route coverage, flexible one-way and round-trip packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free travel anywhere in India. We provide convenient pickup services across Pune including Hinjewadi, Baner, Wakad, Kharadi, Viman Nagar, Hadapsar, Pimpri-Chinchwad, and Pune Railway Station, covering major cities, tourist destinations, pilgrimage routes, and business hubs nationwide. Choose Sanavi Travels for trusted Pan India bus and cab services from Pune, delivering comfort, safety, and seamless nationwide travel experiences.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s most iconic historical landmark, built in 1732 by the Peshwas of the Maratha Empire. Once the seat of Peshwa administration, it features massive stone walls, grand gates like the Delhi Darwaza, and spacious courtyards. Although partially destroyed by fire, its remains reflect Maratha valor and heritage. The evening light-and-sound show brings Pune’s glorious past to life."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a significant monument linked to India’s freedom movement. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it houses a museum displaying photographs, letters, and personal belongings of Gandhi, set amidst serene gardens."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered Ganesh temple. The idol is adorned with gold ornaments and attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations and cultural events."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fort near Pune, famous for the heroic sacrifice of Tanaji Malusare. Visitors can trek or drive up to the fort to enjoy breathtaking views of the Sahyadri ranges. The fort is popular for trekking, history exploration, and traditional Maharashtrian food."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt rock, it features monolithic pillars and a peaceful sanctum. Despite being in a busy area, the temple offers a calm spiritual experience."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts showcasing India’s cultural heritage. The collection includes musical instruments, sculptures, utensils, and ornaments. The recreated Mastani Mahal is a major highlight for visitors."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic views of the city after climbing 103 stone steps. The Parvati Temple complex, built during the Peshwa era, is dedicated to Lord Shiva and Goddess Parvati and is especially popular during sunrise and sunset."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort attracts visitors from across the globe. It offers meditation programs, wellness therapies, and tranquil gardens, making it a center for peace, relaxation, and spiritual growth."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. With bridges, water streams, and manicured lawns, it is ideal for morning walks, family outings, photography, and peaceful relaxation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular leisure destination near Pune, especially during the monsoon season. The scenic reservoir, surrounding hills, and cool breeze make it a favorite spot for evening outings and weekend picnics. It also serves as the gateway to Sinhagad Fort."
  }
]
,




"services": [
  {
    "name": "Pan India Bus & Cab Service Pune",
    "description": "Pan India Bus & Cab Service Pune offers reliable intercity and interstate bus and cab services across India with professional drivers."
  },
  {
    "name": "All India Cab Service Pune",
    "description": "All India Cab Service Pune provides seamless cab travel across cities in India with comfortable vehicles and experienced chauffeurs."
  },
  {
    "name": "All India Bus Service Pune",
    "description": "All India Bus Service Pune delivers safe and comfortable bus travel to multiple cities in India with well-maintained coaches."
  },
  {
    "name": "AC Bus & Cab Pune",
    "description": "AC Bus & Cab Pune ensures a cool and comfortable journey with fully air-conditioned buses and cabs for intercity travel."
  },
  {
    "name": "Luxury Bus & Cab Pune",
    "description": "Luxury Bus & Cab Pune provides premium buses and cars with advanced comfort features for long-distance travel."
  },
  {
    "name": "Corporate Travel Service Pune",
    "description": "Corporate Travel Service Pune offers professional transportation solutions for business travel, meetings, and corporate events."
  },
  {
    "name": "Outstation Bus & Cab Pune",
    "description": "Outstation Bus & Cab Pune provides dependable vehicles for long-distance travel, ensuring safety and comfort."
  },
  {
    "name": "Affordable Bus & Cab Pune",
    "description": "Affordable Bus & Cab Pune delivers budget-friendly transport solutions for intercity travel without compromising comfort."
  },
  {
    "name": "Chauffeur Driven Service Pune",
    "description": "Chauffeur Driven Service Pune ensures stress-free travel with professional drivers handling navigation and scheduling."
  },
  {
    "name": "Best Pan India Transport Pune",
    "description": "Best Pan India Transport Pune provides high-quality transport services across India, focusing on reliability and customer satisfaction."
  },
  {
    "name": "Pune Travel Service India",
    "description": "Pune Travel Service India offers complete bus and cab solutions for travel across India with comfortable vehicles and experienced drivers."
  },
  {
    "name": "Tourist Bus & Cab Pune",
    "description": "Tourist Bus & Cab Pune provides convenient transport for sightseeing and tourist trips with guided support and comfortable vehicles."
  },
  {
    "name": "Event Transport Pune",
    "description": "Event Transport Pune offers organized transportation for corporate events, weddings, and large gatherings with professional drivers."
  },
  {
    "name": "Group Travel Service Pune",
    "description": "Group Travel Service Pune specializes in transporting groups efficiently with buses and cabs for leisure or corporate trips."
  },
  {
    "name": "Online Booking Bus Cab Pune",
    "description": "Online Booking Bus Cab Pune allows easy online reservations for buses and cabs with instant confirmation and reliable service."
  }
],
"tableData": [
  ["Pan India Bus & Cab Service Pune", "All India Cab Service Pune"],
  ["All India Bus Service Pune", "AC Bus & Cab Pune"],
  ["Luxury Bus & Cab Pune", "Corporate Travel Service Pune"],
  ["Outstation Bus & Cab Pune", "Affordable Bus & Cab Pune"],
  ["Chauffeur Driven Service Pune", "Best Pan India Transport Pune"],
  ["Pune Travel Service India", "Tourist Bus & Cab Pune"],
  ["Event Transport Pune", "Group Travel Service Pune"],
  ["Online Booking Bus Cab Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pan India Bus & Cab Service from Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers Pan India bus and cab services from Pune, ideal for intercity travel, corporate trips, family outings, and long-distance journeys across India."
  },
  {
    "WhyChooseheading": "Wide Fleet of Buses and Cabs",
    "WhyChoosedescription": "Choose from a variety of comfortable buses, sedans, SUVs, and premium cars for all types of travel needs across India."
  },
  {
    "WhyChooseheading": "Experienced Drivers and Staff",
    "WhyChoosedescription": "Our licensed and professional drivers are trained for long-distance travel, ensuring safety, punctuality, and a smooth journey."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for all Pan India bus and cab services, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel updates, and route planning for your intercity journeys."
  },
  {
    "WhyChooseheading": "Flexible Booking Options",
    "WhyChoosedescription": "Choose one-way, round-trip, or customized travel packages for your Pan India bus and cab requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses and cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable services, making Sanavi Travels a trusted choice for Pan India travel from Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Pan India bus and cab services from Pune?',
    answer: 'Yes, Sanavi Travels offers reliable Pan India bus and cab services from Pune for all types of long-distance travel.'
  },
  {
    question: 'How can I book Pan India bus and cab services?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of vehicles are available for Pan India travel?',
    answer: 'Sanavi Travels provides buses, sedans, SUVs, and premium cars suitable for intercity and long-distance travel.'
  },
  {
    question: 'Are drivers experienced in long-distance routes across India?',
    answer: 'Yes, our drivers are licensed, professional, and experienced in Pan India routes.'
  },
  {
    question: 'Can I customize my Pan India travel itinerary?',
    answer: 'Absolutely. You can select preferred pickup and drop locations, routes, and travel schedules.'
  },
  {
    question: 'Is Pan India bus and cab service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock Pan India travel services from Pune.'
  },
  {
    question: 'Are vehicles sanitized before long-distance trips?',
    answer: 'Yes, all buses and cabs are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'What payment options are available for Pan India travel?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pan India trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Patil',
    feedback: 'Booked a Pan India cab from Pune with Sanavi Travels. Smooth journey, professional driver, and timely service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Anjali Verma',
    feedback: 'Excellent experience with Pan India bus and cab services. Comfortable vehicles and excellent customer support.',
    rating: 5
  }
];




























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pan India Bus & Cab Service Pune - Sanavi Travels",
  "description": "Book Pan India bus and cab services from Pune with Sanavi Travels. AC and luxury buses and cabs for corporate travel, outstation trips, group travel, events, tourist journeys, and chauffeur-driven transport across India.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};



  return (
    <div>

<Helmet>
  <title>
    Pan India Bus & Cab Service Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury buses and cabs from Pune with Sanavi Travels for Pan India travel. Ideal for corporate trips, outstation journeys, group travel, events, tourist transport, and safe chauffeur-driven service across India."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/171.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Panindiabusandcabservice;